export default {
      id: "toggle-drawers-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#toggle-drawers",
      toString: function () {
        return this.url;
      }
    }